// import React from 'react';
import swal from 'sweetalert';
import store from "../store";
import { DESIGNATION_ROLE } from '../utils/contants';

async function handleErrors(response) {
  if (response.status !== 200 && response.status !== 400) {
    if (response.status === 401) {
      swal('Unauthorized!', 'Please login again', 'error');
      localStorage.removeItem('borewell-token');
      localStorage.removeItem('borewell-user');
      localStorage.removeItem('borewell-companyID');
      localStorage.removeItem('borewell-role');
      window.location.href = "/login";
    } else {
      const parsed = await response.json();
      swal('Internal Server Error!', parsed.error, 'error');
      console.log(parsed.message);
    }

    throw Error(response.statusText);
  }
  return response;
}
function Api() {

  const checkServicePerson = () => {
    return +getRole() === 17 ? true : false;
  }

  const getUserId = () => {
    let profile = store.getState()?.profile ?? null;
    return profile?._id ?? "";

  }

  const getDesignation = () => {
    let profile = store.getState()?.profile ?? null;
    if (!profile) {
      return null;
    }
    let designation = !profile?.designation ? DESIGNATION_ROLE.ADMIN : DESIGNATION_ROLE[+profile?.designation];

    return designation;
  }

  const getRoleTag = () => {
    let profile = store.getState()?.profile ?? null;
    if (!profile) {
      return null;
    }
    let role = "";
    switch (+profile?.role) {
      case 1:
        role = "Admin"
        break;
      case 2:
        role = "Manager"
        break;
      case 3:
        role = "Engineer"
        break;
      default:
        role = ""
        break;
    }

    return role;
  }

  const Login = (token, companyID, role, name) => {
    localStorage.setItem('borewell-token', token);
    localStorage.setItem('borewell-user', name);
    localStorage.setItem('borewell-companyID', companyID);
    localStorage.setItem('borewell-role', role);
  }

  const updateName = (name) => {
    localStorage.setItem('borewell-user', name);
  }

  const LogOut = () => {
    localStorage.removeItem('borewell-token');
    localStorage.removeItem('borewell-user');
    localStorage.removeItem('borewell-companyID');
    localStorage.removeItem('borewell-role');
  }

  const isAuthenticated = () => {
    return localStorage.getItem('borewell-token');
  };

  const getUser = () => {
    return localStorage.getItem('borewell-user');
  };

  const getRole = () => {
    return localStorage.getItem('borewell-role');
  };

  const getCompany = () => localStorage.getItem('borewell-companyID');

  const doFetch = async (type, data, url, sendRaw = false) => {
    let reqData = { ...data };
    const token = localStorage.getItem("borewell-token");
    if (data === null || data === undefined) { reqData = {}; }
    return fetch(url, {
      method: type,
      headers: type !== 'GET' && type !== 'DELETE' ? {
        'Authorization': `Bearer ${token}`,
        'content-type': 'Application/json'
      }
        : {
          'Authorization': `Bearer ${token}`,
        },
      body: type !== 'GET' && type !== 'DELETE' ? JSON.stringify({ ...reqData }) : null,
    })
      .then(handleErrors)
      .then((res) => {
        if (sendRaw) {
            return res;
        }
        
        if (res) {
            return res.json()
        }

        return null;
      })
      .catch(err => console.log(err));
  };

  const doUpload = async (type, data, url) => {
    const token = localStorage.getItem("borewell-token");

    return fetch(url, {
      method: type,
      headers:{
        'Authorization': `Bearer ${token}`,
      },
      body: data,
    })
      .then(handleErrors)
      .then(res => res.json())
      .catch(err => console.log(err));
  };
  return {
    doFetch,
    Login,
    doUpload,
    LogOut,
    isAuthenticated,
    getUser,
    getCompany,
    getRole,
    checkServicePerson,
    updateName,
    getDesignation,
    getRoleTag,
    getUserId
  };
}
const apiInstance = new Api();
export default apiInstance;